import React from 'react';
import PropTypes from 'prop-types';

import DataCard from '../../../common/card/DataCard';

import { formatDate, formatTime } from '../../../../utils/formatTimestamp';

export const RefundDetails = ({ refunds = [] }) => {
  if (!refunds.length) return null;

  return (
    <div className="card-list">
      {refunds.map((refund, index) => {
        const { createdAt, status, updatedAt } = refund;
        const title = `Refund #${index + 1}`;

        const details = [
          { label: 'Created Date', data: formatDate(createdAt) },
          { label: 'Created Time', data: formatTime(createdAt) },
          { label: 'Status', data: status },
          { label: 'Successful Date', data: formatDate(updatedAt) },
        ];

        return <DataCard key={title} title={title} cardData={details} />;
      })}
    </div>
  );
};

RefundDetails.propTypes = {
  refunds: PropTypes.arrayOf(
    PropTypes.shape({
      createdAt: PropTypes.string,
      status: PropTypes.string,
      updatedAt: PropTypes.string,
    }),
  ),
};
